import Hero from "@/sections/Hero";
import Marquee from "@/components/Marquee";
import WhyUs from "@/sections/WhyUs";
import HowItWorks from "@/sections/HowItWorks";
import PortfolioPreview from "@/sections/PortfolioPreview";
import ExistingSiteCta from "@/sections/ExistingSiteCta";
import Services from "@/sections/Services";
import Faq from "@/sections/Faq";
import FinalCta from "@/sections/FinalCta";
import useTitle from "@/lib/useTitle";

const Home = () => {
  useTitle(
    null,
    "Beautiful, mobile-friendly websites designed, launched, hosted, and maintained for U.S. small businesses. Personal service, tailored quotes."
  );
  return (
    <main data-testid="home-page">
      <Hero />
      <Marquee />
      <WhyUs />
      <HowItWorks />
      <PortfolioPreview />
      <ExistingSiteCta />
      <Services />
      <Faq />
      <FinalCta />
    </main>
  );
};

export default Home;
